import '../SASS/navbar.scss'
import { NavLink } from 'react-router-dom'

const Navbar = () => {
  return (
    <header>
      <nav className="nav-bar">
        <NavLink activeclassname="active" className={'about-link'} to="/work">
          Work
        </NavLink>
        <NavLink activeclassname="active" className={'about-link'} to="/about">
          About
        </NavLink>
        <NavLink
          activeclassname="active"
          className={'contact-link'}
          to="/contact"
        >
          Contact
        </NavLink>
      </nav>
    </header>
  )
}

export default Navbar
